"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Page.less");

var _underscore = _interopRequireDefault(require("underscore"));

var _reactBootstrap = require("react-bootstrap");

var _leftArrow = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/left-arrow-1"));

var _close = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/close-1"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Page = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Page, _React$Component);

  var _super = _createSuper(Page);

  function Page(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Page);
    _this = _super.call(this, props);
    _this.addMessage = _this.addMessage.bind((0, _assertThisInitialized2.default)(_this));
    _this.removeMessageAt = _this.removeMessageAt.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      messages: _this.props.messages
    };
    return _this;
  }

  (0, _createClass2.default)(Page, [{
    key: "onBack",
    get: function get() {
      return this.props.onBack;
    }
  }, {
    key: "onCancel",
    get: function get() {
      return this.props.onCancel;
    }
  }, {
    key: "cancelText",
    get: function get() {
      return this.props.cancelText;
    }
  }, {
    key: "addMessage",
    value: function addMessage(message, timeout) {
      var _this2 = this;

      var messages = _underscore.default.clone(this.state.messages || []);

      var index = messages.push(message) - 1;
      this.setState({
        messages: messages
      }, function () {
        if (!_underscore.default.isUndefined(timeout)) window.setTimeout(function () {
          return _this2.removeMessageAt(index);
        }, timeout);
      });
    }
  }, {
    key: "removeMessageAt",
    value: function removeMessageAt(index) {
      var messages = this.state.messages || [];
      messages.splice(index, 1);
      this.setState({
        messages: messages
      });
    }
  }, {
    key: "getBody",
    value: function getBody() {
      return null;
    } // To support inheritance model implemented in ui-order-workflow

  }, {
    key: "getPageClass",
    value: function getPageClass() {
      return '';
    }
  }, {
    key: "getMessages",
    value: function getMessages() {
      return (this.state.messages || []).map(function (message, i) {
        var style = message.type === 'error' ? 'danger' : message.type;
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Alert, {
          key: i,
          bsStyle: style
        }, message.message);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var backButton, cancelButton;

      if (typeof this.onBack === 'function') {
        backButton = /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
          onClick: this.onBack,
          bsStyle: "link"
        }, /*#__PURE__*/_react.default.createElement(_leftArrow.default, null), "Back");
      }

      if (typeof this.onCancel === 'function') {
        cancelButton = /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
          onClick: this.onCancel,
          bsStyle: "link"
        }, this.cancelText);
      }

      var pageClassName = 'page-content ' + this.getPageClass();
      return /*#__PURE__*/_react.default.createElement("div", {
        className: pageClassName
      }, this.props.progressBar, /*#__PURE__*/_react.default.createElement("div", {
        className: "page-article"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "toolbar"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "back-container"
      }, backButton), /*#__PURE__*/_react.default.createElement("div", {
        className: "page-title"
      }, this.props.title), /*#__PURE__*/_react.default.createElement("div", {
        className: "cancel-container"
      }, cancelButton)), this.props.banner, this.getMessages(), this.props.children, this.getBody()));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        title: _propTypes.default.string,
        onBack: _propTypes.default.func,
        onCancel: _propTypes.default.func,
        cancelText: _propTypes.default.node,
        progressBar: _propTypes.default.element,
        messages: _propTypes.default.arrayOf(_propTypes.default.shape({
          type: _propTypes.default.oneOf(['error', 'info', 'success']),
          message: _propTypes.default.string
        })),
        banner: _propTypes.default.element
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        title: 'Default Page Title',
        messages: [],
        cancelText: /*#__PURE__*/_react.default.createElement("span", null, "Cancel", /*#__PURE__*/_react.default.createElement(_close.default, null))
      };
    }
  }]);
  return Page;
}(_react.default.Component);

exports.default = Page;